/**
 * Svelte action that moves the element to document.body on mount and
 * restores it on destroy. Use to escape ancestor containing-blocks
 * (transform / filter / backdrop-filter / perspective) that would
 * otherwise capture `position: fixed` descendants — e.g. modals
 * nested inside a blurred top bar.
 */
export function portal(node: HTMLElement) {
  document.body.appendChild(node);
  return {
    destroy() {
      node.parentNode?.removeChild(node);
    },
  };
}
